window.sfDocumentReady(['route-customer-conditions-index'], () => {
  // initialize data table
  window.setupDatatable('.js-datatable', 'asc');

  // trigger form submission upon confirmation, when delete link is clicked
  $(document).on('click', '#delete_customer_condition_link', function() {
    const shouldDelete = confirm(
      'Are you sure you want to delete this financier?'
    );
    if (shouldDelete) {
      $(this)
        .parents('form:first')
        .trigger('submit');
    } else {
      return false;
    }
  });

  // condition status update
  $('.condition-status').change(function() {
    const status = $(this).val(); // status
    const type = $(this).data('type'); // customer or supplier
    const conditionId = $(this).data('condition-id'); // model id
    const data = {status, type, conditionId}

    window.httpPost('/api/condition/status-update', data, {
      success: () => notifyBox('Saved', 'Condition status updated', 'success'),
      error(response, status, error) {
        console.log(response);
      }
    });
  });
});
